'use client';

import { useReducedMotion, LazyMotion, domAnimation, m } from 'framer-motion';

export default function Template({ children }: { children: React.ReactNode }) {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) return <>{children}</>;

  return (
    <LazyMotion features={domAnimation}>
        {children}
    </LazyMotion>
  );
}
